/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

import React, {DragEventHandler, useState} from "react"

import {Intent, Tag} from "@blueprintjs/core"

export interface DropZoneProps {
    handleDroppedItems: (items: DataTransferItemList) => void
    text: string
}

const DropZone: React.FC<DropZoneProps> = ({handleDroppedItems, text}) => {
    const [isDragActive, setIsDragActive] = useState<boolean>(false)

    const onDropHandler: DragEventHandler<HTMLParagraphElement> = (event) => {
        event.preventDefault()
        setIsDragActive(false)
        handleDroppedItems(event.dataTransfer.items)
    }

    const onDragEnterHandler: DragEventHandler<HTMLParagraphElement> = (
        event
    ) => {
        event.preventDefault()
        setIsDragActive(true)
    }

    const onDragLeaveHandler: DragEventHandler<HTMLParagraphElement> = (
        event
    ) => {
        event.preventDefault()
        setIsDragActive(false)
    }

    return (
        <div
            className="HorizontalElement"
            onDrop={onDropHandler}
            onDragOver={(e) => {
                e.preventDefault()
            }}
            onDragEnter={onDragEnterHandler}
            onDragLeave={onDragLeaveHandler}
        >
            <Tag
                className="no-pointer-events"
                icon="upload"
                intent={isDragActive ? Intent.PRIMARY : Intent.NONE}
                large
            >
                {text}
            </Tag>
        </div>
    )
}

export default DropZone
